import ReactSelect, { GroupBase } from 'react-select';
import classNames from 'classnames';

import { InputLabel } from '@ui/InputLabel';
import { FormError } from '@ui/FormError';

import { SelectProps } from '../../types';
import { getDefaultProps } from '../../utils';

import s from './Select.sss';

export function Select<
  Option,
  IsMulti extends boolean = false,
  Group extends GroupBase<Option> = GroupBase<Option>,
>({
  required, // We need required prop only for label
  ...props
}: SelectProps<Option, IsMulti, Group>) {
  const {
    className,
    label,
    error,
    helpText,
    inputClassName,
  } = props;

  const defaultProps = getDefaultProps(props);
  return (
    <div
      className={classNames(
        s.root,
        className,
      )}
    >
      {label
        && (
        <InputLabel
          className={s.label}
          required={required}
        >
          {label}
        </InputLabel>
        )}

      <ReactSelect
        {...defaultProps}
        {...props}
        className={classNames(s.input, inputClassName)}
      />

      {helpText && <div className={s.helpText}>{helpText}</div>}
      {error && (
        Array.isArray(error)
          ? error.map((e, i) => <FormError key={i}>{e}</FormError>)
          : <FormError>{error}</FormError>
      )}
    </div>
  );
}
